import React, { FC } from 'react';

import { IProductBannerTitle } from './model';

const ProductBannerTitle: FC<IProductBannerTitle> = ({ title }): React.ReactElement => (
  <h1 className="nf-product-banner__product-title">{title}</h1>
);

export default ProductBannerTitle;
